// "InstapayApp Logs" dropdown (2026-08-07) - 5 single-log-group pages, each
// reading today's raw log lines from its own CloudWatch Logs group via the
// BFF's shared /access-logs?source=<slug> route (see index.js's
// ACCESS_LOG_SOURCES map on the backend side - `slug` here must match a key
// there exactly, since it's sent as-is in the `source` query param).
//
// One ordered array (not a plain object) so both the nav dropdown (order
// matters - matches the order given in the original request) and the page
// component (a simple .find() by slug, only 5 entries) can use the same
// source of truth without re-declaring the list twice.
export const INSTAPAY_APP_LOG_SOURCES = [
  {
    slug: 'router-receiver-payment-instruction',
    label: 'Instapay Router: Receiver PaymentInstruction',
    logGroupHint: '/instapay-router/receiver-paymentInstruction',
  },
  {
    slug: 'router-receiver-service-request',
    label: 'Instapay Router: Receiver ServiceRequest',
    logGroupHint: '/instapay-router/receiver-serviceRequest',
  },
  {
    slug: 'router-sender-credit',
    label: 'Instapay Router: Sender Credit',
    logGroupHint: '/instapay-router/sender-credit',
  },
  {
    slug: 'direct-receiver-payment-instruction',
    label: 'Instapay Direct: Receiver PaymentInstruction',
    logGroupHint: '/instapay-direct/receiver-paymentInstruction',
  },
  {
    slug: 'direct-receiver-service-request',
    label: 'Instapay Direct: Receiver ServiceRequest',
    logGroupHint: '/instapay-direct/receiver-serviceRequest',
  },
];
